<template>
  <div
    fluid
    :class="[
      'bg-white rounded',
      {
        'pl-2': !isDialog,
        'border-color': !isDialog,
        'pr-2': !isDialog,
        'pb-2': !isDialog,
        'm-2': !isDialog
      }
    ]"
  >
    <form v-if="!isSchedule" class="">
      <p class="pt-2" v-if="!isDialog">
        Compose SMS <br />
        <small class="text-danger"
          >Important! Sender name registration is now mandatory. Kindly submit
          your sender name for registration by click the <b>+</b> sign button.
          Secondly, before you send your bulk SMS always send to yourself or
          close persons to avoid loss of units caused by blocked words.</small
        >
      </p>
      <div class="form-row mb-3">
        <b-col class="col-10 col-sm-10 col-md-11">
          <v-select
            v-model="selectedSender"
            :options="senders"
            placeholder="Select sender name"
          ></v-select>
        </b-col>
        <b-col class="col-2 col-sm-2 col-md-1">
          <div class="toolbar" role="toolbar">
            <div class="btn-group mr-1 pull-right">
              <b-button variant="light" @click="showSenderNameModal = true"
                ><span class="fa fa-plus"></span>
              </b-button>
            </div>
          </div>
        </b-col>
      </div>
      <div class="form-row mb-3" v-if="newsletter == null && phoneNos == ''">
        <b-col cols="12" sm="12">
          <v-select
            v-model="selectedNewsletters"
            multiple
            :options="newsletters"
            placeholder="Select newsletter(s)"
          ></v-select>
        </b-col>
      </div>
      <div class="form-row mb-3" v-else-if="getNewsletterName != ''">
        <b-col cols="12" sm="12">
          <input
            type="text"
            v-model="getNewsletterName"
            class="form-control"
            readonly
          />
        </b-col>
      </div>
      <div
        class="form-row mb-3"
        v-if="(newsletter != null && phoneNos != '') || newsletter == null"
      >
        <b-col :cols="isMobileDevice ? 11 : 12" :sm="isMobileDevice ? 11 : 12">
          <textarea
            class="form-control"
            id="txtPhoneNo"
            v-if="newsletter != null"
            readonly="toSelected"
            v-model="phoneNos"
            rows="3"
          ></textarea>
          <textarea
            class="form-control"
            id="txtPhoneNo"
            v-else
            v-model="phoneNos"
            rows="3"
            placeholder="Type/paste phone numbers (separated with commas or each number on newline)"
          ></textarea>
        </b-col>
        <b-col v-if="isMobileDevice" cols="1" sm="1">
          <div class="toolbar" role="toolbar">
            <div class="btn-group mr-1 pull-right">
              <b-button
                variant="light"
                class="pull-right"
                @click="importContacts()"
                ><span class="icon-people icons"></span>
              </b-button>
            </div>
          </div>
        </b-col>
      </div>
      <b-row>
        <b-col sm="12" class="ml-auto">
          <div class="toolbar" role="toolbar">
            <div class="btn-group mr-1">
              <b-button
                variant="light"
                v-clipboard:copy="content"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                ><span class="fa fa-copy"></span>
              </b-button>
              <!--b-button variant="light" @click="paste"><span class="fa fa-paste"></span></b-button-->
            </div>
            <b-dropdown variant="light" class="ml-1">
              <template slot="button-content">
                <span class="fa fa-tags"></span>
              </template>
              <b-dropdown-item href="#" @click="insertTag('[name]')"
                >Recipient's Name</b-dropdown-item
              >
              <b-dropdown-item href="#" @click="insertTag('[today]')"
                >Today's Date</b-dropdown-item
              >
              <b-dropdown-item href="#" @click="insertTag('[today+1]')"
                >Future Date</b-dropdown-item
              >
              <b-dropdown-item href="#" @click="insertTag('[today-1]')"
                >Past Date</b-dropdown-item
              >
            </b-dropdown>
            <div class="pull-right">
              <div class="custom-control custom-checkbox custom-control-inline">
                <label
                  >Don't use blocked words
                  <b-btn
                    id="popover-tips"
                    class="padding-0 mb-1"
                    variant="primary"
                    ><i class="icon icon-info mr-1 ml-1"></i></b-btn
                ></label>
              </div>
              <b-popover
                target="popover-tips"
                placement="top"
                triggers="hover focus"
              >
                <template slot="title">Blocked words</template>
                vote, congrats, congrat, congratulations, akpabio, promo,
                promotion, yello, won, win, police, alert,pr0mo w1n, prom0,
                pr0m0, wow, promotional, yellow, sex, sexy, samsung, porn, nude,
                bank, liyel and prize
                <span class="text-danger d-block"
                  >Messages with these words as part of its content are
                  considered as spam and do not get delivered by the network
                  operators.
                  <!--span>In order
                    to guard against loss of sms units from your end, we have put in
                    place a filter to block such words.</span--></span
                >
              </b-popover>
            </div>
          </div>
          <div class="form-group mt-2">
            <textarea
              class="form-control"
              rows="5"
              v-model="content"
              placeholder="Click here to compose your message"
            ></textarea>
            <div class="form-group">
              <span style="visibility:hidden">{{ hasContent }}</span>
              <div class="pull-right">
                <span class="small muted" v-if="hasContent">{{
                  pageCharacters
                }}</span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <b-button
              class="mr-1 mb-1"
              type="button"
              @click="handleSend"
              variant="success"
            >
              <span v-if="!sending">{{ sendActionText }}</span>
              <div class="sk-circle" v-if="sending">
                <div class="sk-circle1 sk-child"></div>
                <div class="sk-circle2 sk-child"></div>
                <div class="sk-circle3 sk-child"></div>
                <div class="sk-circle4 sk-child"></div>
                <div class="sk-circle5 sk-child"></div>
                <div class="sk-circle6 sk-child"></div>
                <div class="sk-circle7 sk-child"></div>
                <div class="sk-circle8 sk-child"></div>
                <div class="sk-circle9 sk-child"></div>
                <div class="sk-circle10 sk-child"></div>
                <div class="sk-circle11 sk-child"></div>
                <div class="sk-circle12 sk-child"></div>
              </div>
              <i v-if="flashSendError" class="fa fa-times"></i>
            </b-button>
            <b-button
              class="mr-1 mb-1"
              type="button"
              @click="handleSaveAsDraft"
              variant="light"
            >
              <span v-if="!saving">{{ saveActionText }}</span>
              <div class="sk-circle" v-if="saving">
                <div class="sk-circle1 sk-child"></div>
                <div class="sk-circle2 sk-child"></div>
                <div class="sk-circle3 sk-child"></div>
                <div class="sk-circle4 sk-child"></div>
                <div class="sk-circle5 sk-child"></div>
                <div class="sk-circle6 sk-child"></div>
                <div class="sk-circle7 sk-child"></div>
                <div class="sk-circle8 sk-child"></div>
                <div class="sk-circle9 sk-child"></div>
                <div class="sk-circle10 sk-child"></div>
                <div class="sk-circle11 sk-child"></div>
                <div class="sk-circle12 sk-child"></div>
              </div>
              <i v-if="flashSaveError" class="fa fa-times"></i>
            </b-button>
            <b-button
              class="mr-1 mb-1"
              type="button"
              @click="handleSchedule"
              variant="info"
              >Schedule Later</b-button
            >
          </div>
        </b-col>
      </b-row>
    </form>
    <form v-else>
      <keep-alive>
        <component
          :is="scheduleComp"
          :message="messageForSchedule"
          :isDialog="isDialog"
          @cancel-schedule="cancelSchedule"
        ></component>
      </keep-alive>
    </form>
    <b-modal
      title="Request Sender name registration"
      hide-footer
      v-model="showSenderNameModal"
    >
      <SenderRegistration />
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import Schedule from "@/components/messages/Schedule";
import SenderRegistration from "@/components/messages/SenderRegistration";
import { intlPhoneFormat, isMobileDevice } from "@/shared/utils";
import { mapGetters, mapActions, mapState } from "vuex";
import { EventBus } from "@/events/bus.event";
import { Plugins } from "@capacitor/core";

const { ContactPicker } = Plugins;

export default {
  name: "ComposeSMS",
  components: {
    vSelect,
    SenderRegistration
  },
  data() {
    return {
      selectedNewsletters: null,
      selectedSender: null,
      content: this.contentToSend,
      sender: "",
      pageCharacters: "",
      hasContent: false,
      showSenderNameModal: false,
      dnd: false,
      sendActionText: "Send Now",
      flashSendError: false,
      saveActionText: "Save Draft",
      flashSaveError: false,
      scheduleComp: Schedule,
      messageForSchedule: null,
      isSchedule: false,
      isMobileDevice: false,
      isPersonalized: false,
      askedForPersonalizing: false
    };
  },
  notifications: {
    copyNotifError: {
      title: "Failed",
      message: "There was error copying the content",
      type: "error"
    },
    copyNotifSuccess: {
      title: "Success",
      message: "Content copied",
      type: "success"
    },
    validationError: {
      title: "Error",
      message: "Kindly type in your message and sender name",
      type: "error"
    },
    scheduleValidationError: {
      title: "Error",
      message: "Kindly type in sender name and recipients phone numbers",
      type: "error"
    },
    showSentSuccess: {
      title: "Success",
      message: "Message sent",
      type: "success"
    },
    showSavedSuccess: {
      title: "Success",
      message: "Message saved",
      type: "success"
    }
  },
  props: {
    newsletters: {
      type: Array,
      required: false,
      default: () => []
    },
    newsletter: {
      type: Object,
      required: false,
      default: () => null
    },
    phoneNos: {
      type: String,
      required: false,
      default: () => ""
    },
    isDialog: {
      type: Boolean,
      required: false,
      default: false
    },
    toSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    contentToSend: {
      type: String,
      required: false,
      default: () => ""
    }
  },
  computed: {
    ...mapGetters("message", [
      "loading",
      "sending",
      "saving",
      "scheduling",
      "serverResponse"
    ]),
    ...mapState("user", ["user"]),
    senders: function() {
      let options = [];
      for (let i = 0; i < this.user.senders.length; i++)
        options.push({
          value: this.user.senders[i].sender,
          label: this.user.senders[i].sender
        });

      return options;
    },
    getNewsletterName: function() {
      return this.newsletter != null ? this.newsletter.name : "";
    }
  },
  created: async function() {
    EventBus.$on("compose-import-contacts", this.populateContacts);

    this.isMobileDevice = await isMobileDevice();
  },
  methods: {
    ...mapActions("message", ["send", "saveAsDraft"]),
    //send composed message asynchroneously
    async handleSend() {
      if (this.sending) return;

      if (this.selectedNewsletters == null) {
        this.selectedNewsletters = [];
      }

      if (this.newsletter != null) {
        this.selectedNewsletters = [
          {
            value: this.newsletter.id,
            label: `${this.newsletter.name} (${this.newsletter.total_subscribers})`
          }
        ];
      }

      // Perform validation on input fields
      if (
        this.selectedSender != null &&
        this.content != "" &&
        (this.phoneNos.length > 0 || this.selectedNewsletters.length > 0)
      ) {
        let recipients = this.phoneNos;
        if (!this.phoneNos.includes("[")) {
          recipients = intlPhoneFormat(this.phoneNos, this.user.zip_code);
        }
        const requestData = {
          sender: this.selectedSender.value,
          message: this.content,
          recipients: recipients,
          newsletter_ids: this.extractItemValues(this.selectedNewsletters),
          use_corporate_route: this.dnd,
          channel_id: 2,
          send_mode_id: 2
        };

        let recipientsArr = recipients !== "" ? recipients.split(",") : [];

        let totalRecipients =
          this.countTotalNewsletterSubscribers(this.selectedNewsletters) +
          recipientsArr.length;

        if (
          !confirm(
            "Total recipients: " +
              totalRecipients +
              " \nClick OK to continue or Cancel to edit."
          )
        )
          return;

        let status = await this.send({ data: requestData });

        if (!status) {
          this.sendActionText = "";
          //this.authenticationState = 'danger'
          this.flashSendError = true;
          //this.showLoginError()
          let interval = setInterval(() => {
            //this.authenticationState = 'primary'
            this.sendActionText = "Send Now";
            this.flashSendError = false;
            clearInterval(interval);
          }, 1000);
        } else {
          this.showSentSuccess();
          if (this.newsletter !== null) {
            this.content = "";
            this.selectedSender = null;
          }
        }
      } else {
        this.validationError();
      }
    },
    // save compose message as draft
    async handleSaveAsDraft() {
      if (this.saving) return;

      if (this.selectedNewsletters == null) {
        this.selectedNewsletters = [];
      }

      if (this.newsletter != null) {
        this.selectedNewsletters = [
          {
            value: this.newsletter.id,
            label: `${this.newsletter.name} (${this.newsletter.total_subscribers})`
          }
        ];
      }

      // Perform validation on input fields
      if (
        this.selectedSender != null &&
        this.content != "" &&
        (this.phoneNos.length > 0 || this.selectedNewsletters.length > 0)
      ) {
        let recipients = this.phoneNos;
        if (!this.phoneNos.includes("[")) {
          recipients = intlPhoneFormat(this.phoneNos, this.user.zip_code);
        }

        const requestData = {
          sender: this.selectedSender.value,
          message: this.content,
          recipients: recipients,
          newsletter_ids: this.extractItemValues(this.selectedNewsletters)
        };

        let status = await this.saveAsDraft({ data: requestData });
        if (!status) {
          this.saveActionText = "";
          //this.authenticationState = 'danger'
          this.flashSaveError = true;
          //this.showSaveError()
          let interval = setInterval(() => {
            //this.authenticationState = 'primary'
            this.saveActionText = "Save Draft";
            this.flashSaveError = false;
            clearInterval(interval);
          }, 1000);
        } else {
          this.showSavedSuccess();
        } /**/
      } else {
        this.validationError();
      }
    },
    handleSchedule: function() {
      if (this.scheduling) return;

      if (this.selectedNewsletters == null) {
        this.selectedNewsletters = [];
      }

      if (this.newsletter != null) {
        this.selectedNewsletters = [
          {
            value: this.newsletter.id,
            label: `${this.newsletter.name} (${this.newsletter.total_subscribers})`
          }
        ];
      }

      // Perform validation on input fields
      if (
        this.selectedSender.value != "" &&
        (this.phoneNos.length > 0 ||
          this.newsletter != null ||
          this.selectedNewsletters.length > 0)
      ) {
        let newsletters =
          this.newsletter != null
            ? [this.newsletter.id]
            : this.extractItemValues(this.selectedNewsletters);
        let sendModeId = this.newsletter == null ? 1 : 2;

        let recipients = this.phoneNos;
        if (!this.phoneNos.includes("[")) {
          recipients = intlPhoneFormat(this.phoneNos, this.user.zip_code);
        }

        const requestData = {
          sender: this.selectedSender.value,
          message: this.content,
          recipients: recipients,
          newsletter_ids: newsletters,
          use_corporate_route: this.dnd,
          channel_id: 2,
          send_mode_id: sendModeId
        };

        this.messageForSchedule = requestData;

        this.isSchedule = true;
      } else {
        this.scheduleValidationError();
      }
    },
    insertTag: function(tag) {
      this.content += tag;
    },
    onCopy: function(e) {
      this.copyNotifSuccess();
    },
    onCopyError: function(e) {
      this.copyNotifError();
    },
    async paste(input) {
      const text = await navigator.clipboard.readText();
      this.content += text;
    },
    extractItemValues: function(items) {
      let values = [];

      items.forEach(function(item, key) {
        values.push(item.value);
      });

      return values;
    },
    countTotalNewsletterSubscribers: function(items) {
      let total = 0;

      items.forEach(function(item, key) {
        let subscribers = item.label.substring(
          item.label.lastIndexOf("(") + 1,
          item.label.length - 1
        );
        total += parseInt(subscribers);
      });

      return total;
    },
    cancelSchedule: function() {
      this.isSchedule = false;
    },
    importContacts: async function() {
      const res = await ContactPicker.open();
      // res.value is an array of contacts

      if (res.value.phoneNumbers.length == 0) {
        return;
      }

      if (this.phoneNos.trim() == "") {
        this.askedForPersonalizing = false;
      }

      if (!this.askedForPersonalizing) {
        this.isPersonalized = confirm(
          "Would you like to personalize your message like addressing recipients by names?"
        );
        this.askedForPersonalizing = true;
      }
      let recipient = this.isPersonalized
        ? `[${res.value.phoneNumbers[0]}:${res.value.displayName}]`
        : res.value.phoneNumbers[0];
      if (this.phoneNos.trim() != "") {
        this.phoneNos += "\n";
      }
      this.phoneNos += recipient;
    },
    populateContacts: function(selectedContacts) {
      //this.phoneNos = selectedContacts
    }
  },
  watch: {
    content(newValue, oldValue) {
      const MAX_SINGLE = 160;
      const MAX_MULTIPLE = 151;
      let pageLen =
        this.content.length <= MAX_SINGLE ? MAX_SINGLE : MAX_MULTIPLE;
      let pages = Math.ceil(this.content.length / pageLen);

      this.pageCharacters = `Pages: ${pages} (Maximum Charaters: ${pageLen *
        pages}), Characters left: ${pageLen * pages -
        this.content.length}, Typed Characters: ${this.content.length}`;

      this.hasContent = this.content.length > 0;
    }
  }
};
</script>

<style scoped>
.border-color {
  border: 1px #edebe9 solid;
}
.sk-circle {
  margin: 0 auto 1px auto;
  width: 20px;
  height: 20px;
  position: relative;
  color: white !important;
}
</style>
